import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListParsedDataComponent } from './list-parsed-data/list-parsed-data.component';

const routes: Routes = [
    {
        path: '',
        component: ListParsedDataComponent,
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiDocumentParsingRoutingModule { }
